import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Table, Tag, Skeleton, Spin } from "antd"
import moment from "moment"

import { formatCurrency } from "../../../lib/utilities"
import {
    regenerateQuickbooksFile,
    selectQuickbooksFiles,
    selectQuickbooksFilesLoading,
    selectQuickbooksGenerating,
} from "../clientBatchingSlice"

// One QuickBooks import file per batch date, rebuilt from that day's global batches. "Stale" means
// a batch was edited, deleted or re-dated after the file was built; Regenerate rebuilds it.
export default function QuickbooksFilesTable() {
    const dispatch = useDispatch()
    const files = useSelector(selectQuickbooksFiles)
    const loading = useSelector(selectQuickbooksFilesLoading)
    const generating = useSelector(selectQuickbooksGenerating)

    return (
        <div className="muc-table card">
            <div className="card-body">
                {/* one wrapper: .card-body is a flex row */}
                <div>
                    <div className="card-body-heading">
                        <div className="badged-header">
                            <h2>QuickBooks Files</h2>
                            <div className="badge">{files.length}</div>
                        </div>
                    </div>

                    <p className="p-10">
                        One invoice import per batch date, covering every global batch with that date. Last 14 days.
                    </p>

                    <Skeleton active loading={loading && files.length === 0}>
                        <Table dataSource={files} rowKey={(r) => r.file_date} pagination={false}>
                            <Table.Column
                                title="Batch date"
                                key="file_date"
                                render={(text, record) => moment(record.file_date).format("ddd, MMM D, YYYY")}
                            />
                            <Table.Column title="Batches" key="batch_count" dataIndex="batch_count" align="right" />
                            <Table.Column
                                title="Total"
                                key="total"
                                dataIndex="total"
                                align="right"
                                render={(text) => formatCurrency(text)}
                            />
                            <Table.Column
                                title="File"
                                key="file"
                                // Spinner first: a rebuild in flight wins over whatever is stored.
                                render={(text, record) => {
                                    if (generating.includes(record.file_date)) return <Spin size="small" />
                                    if (record.missing || !record.batch_file_url) return <Tag color="orange">Missing</Tag>
                                    return (
                                        <>
                                            <a href={record.batch_file_url} target="_blank" rel="noopener noreferrer">
                                                Download
                                            </a>
                                            {record.stale && (
                                                <Tag color="red" style={{ marginLeft: "8px" }}>
                                                    Stale
                                                </Tag>
                                            )}
                                        </>
                                    )
                                }}
                            />
                            <Table.Column
                                title="Generated"
                                key="generated_at"
                                render={(text, record) =>
                                    record.generated_at ? moment(record.generated_at).format("MMM D, h:mm A") : ""
                                }
                            />
                            <Table.Column
                                title="Actions"
                                key="actions"
                                render={(text, record) => (
                                    <div className="table-action-links">
                                        {(record.batch_count > 0 || record.stale) && !generating.includes(record.file_date) && (
                                            <a
                                                href="javascript:;"
                                                onClick={() => dispatch(regenerateQuickbooksFile(record.file_date))}
                                            >
                                                Regenerate
                                            </a>
                                        )}
                                    </div>
                                )}
                            />
                        </Table>
                    </Skeleton>
                </div>
            </div>
        </div>
    )
}
